import React from 'react'
import { useForm, useFetch } from '../../hooks'
import TextArea from '../../components/inputs/TextArea';
import Button from '../../components/inputs/Button';
import Buttons from '../../modules/Buttons';
import { Form } from '../../modules/Form/styled'

const Note = ({ endpointNote, rowid, note, buttonsTranslation, handleToggleIsOpenDrawer, setDiaryAlerts }) => {
    const { doFetch } = useFetch({
        url: endpointNote,
        method: 'POST'
    })

    const addNote = async values => {
        try {
            const res = await doFetch({
                data: {
                    rowid,
                    note: values.note
                }
            })
            if (res === 1) {
                await setDiaryAlerts(prevDiary => {
                    return prevDiary.map(diary => {
                        if (diary.rowid === rowid) {
                            return {
                                ...diary,
                                note: values.note
                            }
                        }
                        return diary
                    })
                })
                handleToggleIsOpenDrawer()
            }
        } catch (err) {
            // TODO Change error message or use popup
            return Promise.reject({ note: 'Wystąpił bład, spróbuj póżniej' })
        }
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: addNote,
        initValues: { note: note || "" }
    })

    return (
        <Form
            fullWidth
            onSubmit={handleSubmit}
        >
            <TextArea
                name='note'
                onChange={handleChange}
                value={values.note}
                error={errors.note}
            />
            <Buttons>
                <Button
                    type='button'
                    onClick={handleToggleIsOpenDrawer}
                    width='50%'
                >
                    {buttonsTranslation.cancel}
                </Button>
                <Button
                    type='submit'
                    width='50%'
                    green
                >
                    {buttonsTranslation.submit}
                </Button>
            </Buttons>
        </Form>
    )
}

export default Note